import { RepairPriority, RepairPriorityCode } from "../Repair/CreateRepair";

export const PriorityCodeAndNames = [
    {
        key: RepairPriorityCode.Emergency,
        value: RepairPriority.Emergency,
    },
    {
        key: RepairPriorityCode.NextAvailable,
        value: RepairPriority.NextAvailable,
    },
    {
        key: RepairPriorityCode.DampAndMould,
        value: RepairPriority.DM14Days,
    },
    {
        key: RepairPriorityCode.NextAvailableRecallRC,
        value: RepairPriority.NextAvailableRecallRC
    },
    {
        key: RepairPriorityCode.NextAvailableRecallRRC,
        value: RepairPriority.NextAvailableRecallRC
    },
    {
        key: RepairPriorityCode.V14,
        value: RepairPriority.NextAvailable14Days,
    },
    {
        key: RepairPriorityCode.DampAndMouldEmergency,
        value: RepairPriority.DM24Hours
    },
    {
        key: RepairPriorityCode.DampAndMouldLowRisk,
        value: RepairPriority.DampAndMouldLowRisk,
    },
    {
        key: RepairPriorityCode.DampAndMouldSignificant,
        value: RepairPriority.DampAndMouldSignificant,
    }
]